import { Quote, UserRound } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export default function Testimonials({ content }) {
  return (
    <section className="bg-mist-blue bg-dots-blue py-24" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <SectionHeading
          number="11"
          eyebrow="Testimoni"
          title="Apa Kata Mereka?"
          description="Testimoni pelanggan akan ditampilkan di sini setelah tersedia."
        />
        <div className="grid gap-6 md:grid-cols-3">
          {content.testimonials.map((t, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <figure
                className="flex h-full flex-col rounded-2xl border border-dashed border-brand/25 bg-white p-7 shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
                data-testid={`testimonial-card-${i}`}
              >
                <Quote className="h-7 w-7 text-brand/40" />
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-slate-600">{t.text}</blockquote>
                <figcaption className="mt-6 flex items-center gap-3 border-t border-slate-100 pt-5">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-mist">
                    <UserRound className="h-5 w-5 text-brand" />
                  </span>
                  <span>
                    <span className="block text-sm font-semibold text-brand-dark">{t.name}</span>
                    <span className="text-xs text-slate-500">{t.role}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
